module.exports = ".team-group-content table {\n    margin-bottom: 0;\n}\n\n.team-group-content .btn-remove-item {\n    color: red;\n    cursor: pointer;\n}\n\n.team-group-button-actions hr {\n    margin-top: 0;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/consultants/consultants-teamGroups/consultants-teamGroups-edit/consultants-teamGroups-edit.component.css
// module id = ./src/app/views/consultants/consultants-teamGroups/consultants-teamGroups-edit/consultants-teamGroups-edit.component.css
// module chunks = main